import { localStorageService } from "@next-platform/client-common-core";

import { ISPARTNER_LOCALSTORAGE_KEY } from "@/constants";

const useIsMultiLangEnabled = () => {
  const isPartner = JSON.parse(localStorageService.getItem(ISPARTNER_LOCALSTORAGE_KEY) as unknown as string) || false;
  return {
    isMultiLangEnabled: !isPartner as boolean,
    isLoading: false,
  }; // Multi-language feature is disabled for partner users
};

export default useIsMultiLangEnabled;
